import React, { useState, useRef, useEffect } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import NewService from "./NewService";
// import ListService from './ListService';
import StickyBox from "react-sticky-box";
import { Button, Container } from "react-bootstrap";
import { serviceMaster as items } from "../shared/data";

function ImportService() {
  const containerRef = useRef();
  const [services, setServices] = useState([]);

  useEffect(() => {
    console.log(containerRef);
    const allNewService = Array.from(
      document.getElementsByClassName("new-service")
    );
    if (allNewService.length > 0) {
      const latest = allNewService[allNewService.length - 1];
      const nameField = latest.querySelectorAll(".service-name");
      nameField[0].focus();
      // console.log(nameField);
    }
  }, [services]);

  const removeService = (e, id) => {
    // console.log(e,id);
    const newServices = services.filter((service) => service.id !== id);
    setServices(newServices);
  };

  const branches = [
    {
      id: 1,
      name: "Main Branch",
    },
    {
      id: 2,
      name: "Sub Branch",
    },
  ];
  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    console.log(string, results);
  };

  const handleOnHover = (result) => {
    // the item hovered
    console.log(result);
  };

  const handleOnSelect = (item) => {
    // the item selected
    // let allServices = services;
    // allServices.push(item);
    setServices([...services, item]);
  };

  const handleOnFocus = () => {
    console.log("Focused");
  };

  const formatResult = (item) => {
    return (
      <>
        <span
          style={{ display: "block", textAlign: "left" }}
        >{`${item.name} (${item.group})`}</span>
      </>
    );
  };

  return (
    <Container>
      <StickyBox offsetTop={20} offsetBottom={20} style={{ zIndex: 1 }}>
        <div className="my-3">
          <ReactSearchAutocomplete
            items={items}
            onSearch={handleOnSearch}
            onHover={handleOnHover}
            onSelect={handleOnSelect}
            onFocus={handleOnFocus}
            autoFocus
            formatResult={formatResult}
            styling={{ zIndex: 4 }}
          />
        </div>
      </StickyBox>

      <div ref={containerRef}>
        {services.map(function (service) {
          return (
            <NewService
              serviceData={service}
              key={service.id}
              branches={branches}
              removeService={removeService}
            />
          );
        })}
      </div>
      {services.length > 1 && (
        <div className="my-3 d-flex justify-content-end">
          <Button>Save All</Button>
        </div>
      )}
    </Container>
  );
}

export default ImportService;
